// Условия списка пользователей в адресе страницы: поиск, роль, состояние, сортировка.
import { roles, userSortFields, userStates } from '@kp/contracts';
import type { Role, SortValue, UserState } from '@kp/contracts';

export type UserSortField = (typeof userSortFields)[number];
export type UserSort = SortValue<UserSortField>;

export interface UsersSearch {
  q?: string;
  role?: Role;
  state?: UserState;
  sort?: UserSort;
}

const sortValues = userSortFields.flatMap((field) => [field, `-${field}`]) as UserSort[];

export function parseUsersSearch(search: Record<string, unknown>): UsersSearch {
  const result: UsersSearch = {};
  if (typeof search.q === 'string' && search.q.trim() !== '') result.q = search.q;
  if (typeof search.role === 'string' && (roles as readonly string[]).includes(search.role)) {
    result.role = search.role as Role;
  }
  if (
    typeof search.state === 'string' &&
    (userStates as readonly string[]).includes(search.state)
  ) {
    result.state = search.state as UserState;
  }
  if (typeof search.sort === 'string' && (sortValues as readonly string[]).includes(search.sort)) {
    result.sort = search.sort as UserSort;
  }
  return result;
}

export function hasFilters(search: UsersSearch): boolean {
  return Boolean(search.q || search.role || search.state);
}

export const userSortLabels = {
  fullName: 'ФИО',
  email: 'Почта',
  createdAt: 'Дата создания',
} as const satisfies Record<UserSortField, string>;
